import { ClientState } from "../ClientState";
import { Resourceful, Resourceful2 } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { LogGroup, Size } from ".././MyHelpers";
import { MultigameParams } from "../MultigameParams";
import { SlotGameInitData } from "../SlotGameInitData";
import { GamePresentation } from "./GamePresentation";
import { ScatterRandomAwardResults } from "./ScatterRandomAward/ScatterRandomAward";
import { IWinLine } from "./WinLine";
import { Money } from "../Money";

import { Bonus } from "./Bonus/Bonus";
import { MultigameUpdateDenomCallBack, MultigameGameStateChangedCallback } from "../Multigame";
import { Button } from "../IO";
import { BetConfig, BetRequest, BetType, CanCollectParams, DoubleUpGameState, HistoryGame, ISimpleBonusAction, SharedJackpotGameState, SharedJackpotWin, SimpleSlotGameState, SlotGameBet } from "../api";
import { ActionStats, IHistoryGame } from "./IHistoyGame";
export interface SlotSpinResult
{
	LineCount: number;

	// index of reels, that hit something
	Lines: IWinLine[];

	ReelStops: number[];

	// win of the basegame, in cents, after features
	TotalWin: number;

	ScatterWin:number;

	// name of the triggered bonus
	Bonus: Bonus;

	// trigger result
	//BonusTriggerResults: any;
	//TriggerResults: any;
	TriggerResults: ITriggerResultDic;

	// from which reel on is the anticipation
	Anticipation: number;

	FeaturesTriggered: number;
	FeatureResults: {
		ExpandingWildBulk: any; // todo
		ExpandingWildReel: any; // todo

		ScatterRandomAward: ScatterRandomAwardResults;
	};
	ExpectedSymbols: string[][];
}

export type ITriggerResultDic =
{
	[key in Bonus]?: TriggerResult
}

export interface TriggerResult
{
	willTrigger:boolean;
    anticipation:number;
    count: number;
    symbolsTriggered: SymbolPosition[];
}

export interface SymbolPosition
{
	Row:number;	
	Reel:number;
}

const enum HandpayReason
{
	NoHandpay = "NoHandpay",
	PaytableWinLimit = "PaytableWinLimit",
	ProgressiveWinLimit = "ProgressiveWinLimit",
	CreditLimit = "CreditLimit",
	AftDenied = "AftDenied",
}

export interface HandpayData
{
	HandpayReason: HandpayReason;
	GameName: string | undefined;
	GameIndex: number;
	ProgressiveIndex: number;
	HandpayAmount: Money | undefined;
}

// export interface HandpayPendingParams
// {
// 	PendingHandpays: HandpayData[] | undefined;
// }

export interface CashInParams
{
	Cashin:  Money | undefined;
	Current: Money | undefined;
}

export interface CashOutParams
{
	Cashout: Money | undefined;
	Current: Money | undefined;
}

// export interface CanCollectParams
// {
// 	CanCollect: boolean;
// 	TotalWin: Money;
// 	CurrentCreditTotal: Money;
// }

export interface BonusPickElement
{
	AvailablePicks: number;
}

export interface BonusPickReveal
{
	RevealedValue: any;
}

export interface BonusRevealRemaining
{
	Remaining: BonusPickReveal[];
	NextPage:boolean;
	/*
	Remaining: any[];
	NextPage:boolean;
	*/
}

export interface RunResultMessage
{
	RunResult: IRunResult;
	BonusStartConfig: IBonusStartConfig;
}

export interface IRunResult
{
	//RunResult: IRunResult;
	BonusStartConfig: IBonusStartConfig;
	NextBonus: Bonus;
	WinAmount: Money;
}

export interface BonusTotalResult 
{
	BonusResult: any;
}

export interface BonusFinish
{
	// no params
}

// export enum InputType
// {
// 	Unknown = "Unknown",
// 	Button = "Button",
// 	Lock = "Lock",
// }

// export enum InputFunction
// {
// 	// unmapped
// 	Unmapped = "Unmapped",

// 	// buttons
// 	Payout = "Payout",
// 	Spin = "Spin",
// 	Help = "Help",
// 	GamesMenu = "GamesMenu",
// 	Autoplay = "Autoplay",
// 	CallAttendant = "CallAttendant",
// 	MaxBet = "MaxBet",
// 	Bet1 = "Bet1",
// 	Bet2 = "Bet2",
// 	Bet3 = "Bet3",
// 	Bet4 = "Bet4",
// 	Bet5 = "Bet5",
// 	Bet6 = "Bet6",
// 	Bet7 = "Bet7",
// 	Bet8 = "Bet8",
// 	Bet9 = "Bet9",
// 	Bet10 = "Bet10",
// 	BetUp = "BetUp",
// 	BetDown = "BetDown",
// 	NextBet = "NextBet",

// 	// locks
// 	Operator = "Operator",
// 	Attendant = "Attendant",

// 	// doors
// 	BellyDoor = "BellyDoor",
// 	CardCageDoor = "CardCageDoor",
// 	CashboxDoor = "CashboxDoor",
// 	DropDoor = "DropDoor",
// 	SlotDoor = "SlotDoor"
// }

// interface ButtonChangedParams
// {
// 	Button: ButtonType;
// 	//ButtonIndex?: number;
// 	Pressed: boolean;
// }

// interface SwitchChangedParams
// {
// 	Switch: string;
// 	SwitchIndex?: number;
// 	Triggered: boolean;
// }

// interface LightChangedParams
// {
// 	Light: string;
// 	LightIndex?: number;
// 	On: boolean;
// }

// export interface MachineLockedParams
// {
// 	Code: string,
// 	Reason: string,
// }

// export interface MachineUnlockedParams
// {

// }

// export interface JackpotValuesUpdateParams
// {
// 	JackpotValues: JackpotValue[];
// }

export interface WallDisplayWinMessage
{
	Duration: number;
	JackpotName: string;
	Win: number;
}


// export interface JackpotValue extends ApiJackpotValue
// {
// 	//Id: number;
// 	Name: JackpotName;
// 	Value: number;
// }

// export interface MenuEnterParams
// {
// 	KeyCode: string;
// 	AccessLevel: MenuAccessLevel;
// }

export interface IBonusStartConfig
{
	actions: ISimpleBonusAction[];
	bet: SlotGameBet;
}

export interface BonusStartConfigMessage
{
	StartConfig: IBonusStartConfig;
}

export type SlotGameEndedCallback = () => boolean;
export type StopAllAnimationsCallback = () => void;
export type StartAllAnimationsCallback = () => void;

export abstract class SlotGame implements Resourceful2, IHistoryGame
{
	public name: string = "";
	public index: number = 0;

	protected clientState: ClientState = null;

	protected _selectedBetIndex: BetRequest = {Index: 0, Type: BetType.Normal};

	public get selectedBetIndex(): BetRequest
	{
		return this._selectedBetIndex;
	}

	public set selectedBetIndex(value: BetRequest)
	{
		console.log(new Error("ChangeBetIndex: " + JSON.stringify(value)));
		this._selectedBetIndex = value;
	}



	protected get selectedBet(): SlotGameBet
	{
		return this.initData.EnabledBets[this.selectedBetIndex.Index].Bet
	}

	public get selectedBetConfig(): BetConfig
	{
		return this.initData.EnabledBets[this.selectedBetIndex.Index];
	}

	public GetSelectedBet(): SlotGameBet
	{
		return this.selectedBet;
	}

	protected initData: SlotGameInitData = null;

	protected resid: ResourceIdentifier = null;
	protected logGroup: LogGroup = null;

	public isDeluxGame : boolean = false;

	public constructor(initData: SlotGameInitData, multigameParams: MultigameParams) {
		this.name = initData?.Meta?.onlineParams?.original ?? initData.Name;
		this.index = initData.Index;
		this.initData = initData;
		
		this.selectedBetIndex = {Index: 0, Type: BetType.Normal};

		this.clientState = multigameParams.clientState;

		this.resid = multigameParams.resid.Add(initData.Name);
		
		this.logGroup = new LogGroup(["Slot", initData.Name]);
	}

	public get InitData(): SlotGameInitData
	{
		return this.initData;
	}

	public Exit():void
	{
		
	}
	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
	}

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
	}

	public abstract Update(): void;
	public abstract View(): HTMLElement;
	public abstract Spin(): void;
	//public abstract GameStartAllowed(): void;
	//public abstract GameStartDenied(): void;
	public abstract OnSpinResult(spinResult: SimpleSlotGameState): void;
	

	//bonus
	public abstract OnBonusStartConfig(config: BonusStartConfigMessage): void;
	public abstract OnBonusPickElement(pickElem: BonusPickElement): void;
	public abstract OnBonusPickReveal(pickReveal: BonusPickReveal): void;
	public abstract OnBonusRevealRemaining(revealReamining: BonusRevealRemaining): void;
	//public abstract OnBonusRunResult(run:IRunResult): void;
	//public abstract OnBonusRunResult(run:RunResultMessage): void;
	public abstract OnBonusTotalResult(totalResult: BonusTotalResult):void;
	public abstract OnBonusFinish(finish:BonusFinish): void;

	//public abstract Bonus(): SlotBonus;

	// public abstract SelectLine(lineIndex:number): void;
	// public abstract SelectDenom(denomIndex:number): void;
	// public abstract SelectBet(betIndex: number): void;
	public abstract SelectBet2(betIndex: number): void;
	public abstract GetMinimumBet(): Money;
	public abstract SelectMinimumBet(): void;
	

	//public abstract Recover(lastGame:IHistoryEntry, bonusStartConfig: IBonusStartConfig[]): void ;
	public abstract ContinueUnfinishedGame(gameState: SimpleSlotGameState): void;
	public abstract ContinueUnfinishedDoubleUp(gameState: DoubleUpGameState): void;
	
	public abstract GameSelected(): void;
	public abstract GameExit(): void;
	public abstract GamesMenu(): void;

	


	// public abstract GetSelectedLineIndex(): number;
	// public abstract GetSlectedDenomIndex(): number;
	//public abstract GetSelectedTotalBet(): number;

	public abstract AutoplayDisable():void;
	//protected abstract Recover(lastGame:IHistoryEntry):void;


	//
	public abstract GetPreview(): HTMLElement;

	public abstract GetPresentation(): GamePresentation;

	public GameStartedCallback: () => void = null;
	public GameEndedCallback: () => boolean = null;

	// protected slotGameEndedCallback: SlotGameEndedCallback = null;
	// public SetGameEndedCallback(callback: SlotGameEndedCallback): void {
	// 	this.slotGameEndedCallback = callback;
	// }

	// protected OnGameEnded()
	// {
	// 	if (this.slotGameEndedCallback != null) 
	// 	{
	// 		return this.slotGameEndedCallback();
	// 	}

	// 	return true;
	// }

	// public Intruduction(params:Introduction)
	// {}


	public OnBetChanged: (betIndex: number) => void = null;

	public OnButtonChanged(button: Button, pressed: boolean)
	{}

	public UpdateDenom: MultigameUpdateDenomCallBack = null;
	public GameStateChanged: MultigameGameStateChangedCallback = null;

	protected stopAllAnimationsCallbacks: StopAllAnimationsCallback[] = [];
	public AddStopAllAnimationsCallback(callback: StopAllAnimationsCallback): void
	{
		this.stopAllAnimationsCallbacks.push(callback);
	}

	protected StopAllAnimationsRequest(): void
	{
		for (let i = 0; i < this.stopAllAnimationsCallbacks.length; i++)
		{
			this.stopAllAnimationsCallbacks[i]();
		}
	}


	protected startAllAnimationsCallbacks: StartAllAnimationsCallback[] = [];
	public AddStartAllAnimationsCallback(callback: StartAllAnimationsCallback): void
	{
		this.startAllAnimationsCallbacks.push(callback);
	}

	protected StartAllAnimationsRequest(): void
	{
		for (let i = 0; i < this.startAllAnimationsCallbacks.length; i++)
		{
			this.startAllAnimationsCallbacks[i]();
		}
	}

	public abstract HistoryView(actionIndex: number, gameState?:SimpleSlotGameState): HTMLElement;
    //public abstract HistoryViewParsed(actionIndex: number, gameState: SimpleSlotGameState): HTMLElement
	public abstract HistoryStats2(actionIndex:number, gameState?:SimpleSlotGameState): ActionStats
    //public abstract HistoryStatsParsed(actionIndex:number, gameState: SimpleSlotGameState): ActionStats

	public abstract CreatePlayLines(lines:number [][], slotSize: Size, lineIndex: number,DivSize:Size,displayNumber: boolean) : string
	
	//public abstract BonusList(): Map<string, SlotBonus>;

	public RedrawAllReels() {}

	// public RequestCallAttendantCallback: () => void = null;
	// public RequestCancelCallAttendantCallback: () => void = null;
	
	public abstract CallAttendant(): void;
	public abstract CancelCallAttendant(): void


	public OnBetSelect: (selectedBet : SlotGameBet) => void = null;

	// public RequestPayoutCallback: () => void = null;
	// public RequestCancelPayoutCallback: () => void = null;

	// public abstract Payout(): void;
	// public abstract CancelPayout(): void

	public abstract IsIdle(): boolean;

	//public PixiCanvasCrash() : void{};
	//public DestroyPixi():void{};
	//public ReCreatePixiReels():void{};
	//public abstract FillingPotDebuggerLevel();
	//public abstract FillingPotDebuggerPath();
	//public abstract FillingPotDebuggerBonusWin();
	//public abstract FillingPotRAAnimationDebugger(aniamtionToPlay : string);
	public abstract FillingPotDebuggerAnims(command : string , potIndex? : number , allComand? : RegExpMatchArray );
	//public abstract JPSharedDebugger(); 
	public abstract SharedJackpotWin(win: SharedJackpotWin);
	public abstract BonusMultiplierDebugger(); 

	public abstract SharedJackpotUpdate(sharedJackpotGameState: SharedJackpotGameState): void;
	public abstract Destroy(): void;

	public abstract RamclearFillingPot();
}

    export type { ActionStats };
